import * as React from 'react'

import Svg, {
  SvgProps,
  Path,
  G,
  Rect,
  Circle,
  Defs,
  ClipPath,
} from 'react-native-svg'

const EmptyFolder = (props: SvgProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={82}
    height={74}
    fill="none"
    {...props}
  >
    <Path
      fill="#D1D9E9"
      d="M60.011 12.906H16.987a4.821 4.821 0 0 0-4.821 4.82v23.637h52.666V17.727a4.821 4.821 0 0 0-4.821-4.821Z"
    />
    <Path
      fill="#ECEFF5"
      d="M67.713 24.59v29.54H9.285V24.59a5.35 5.35 0 0 1 5.348-5.35h47.732a5.35 5.35 0 0 1 5.348 5.35Z"
    />
    <G clipPath="url(#a)" opacity={0.6}>
      <Path
        fill="#BED5FA"
        d="M35 33.5a9.476 9.476 0 0 1-3.099 7.019 9.467 9.467 0 0 1-6.402 2.48 9.467 9.467 0 0 1-6.401-2.48A9.5 9.5 0 1 1 35 33.499Z"
      />
      <Path
        fill="#9FC4FE"
        d="M35 33.5a9.476 9.476 0 0 1-3.099 7.019 9.467 9.467 0 0 1-6.402 2.48V24a9.5 9.5 0 0 1 9.5 9.5Z"
      />
      <Path
        fill="#7985EB"
        d="M31.901 40.481v.038a9.466 9.466 0 0 1-6.402 2.48 9.467 9.467 0 0 1-6.401-2.48v-.038a6.412 6.412 0 0 1 4.188-6.007 6.363 6.363 0 0 1 2.213-.394c.778 0 1.524.139 2.214.394a6.412 6.412 0 0 1 4.188 6.007Z"
      />
      <Path
        fill="#3975D0"
        d="M31.901 40.481v.038a9.466 9.466 0 0 1-6.402 2.48v-8.92c.778 0 1.524.14 2.214.395a6.412 6.412 0 0 1 4.188 6.007Z"
      />
      <Path
        fill="#FFDBA9"
        d="M29.426 31.233a3.93 3.93 0 0 1-3.927 3.927 3.931 3.931 0 0 1-3.926-3.927 3.931 3.931 0 0 1 3.926-3.926 3.93 3.93 0 0 1 3.927 3.926Z"
      />
      <Path
        fill="#FFC473"
        d="M29.426 31.233a3.93 3.93 0 0 1-3.927 3.927v-7.853a3.93 3.93 0 0 1 3.927 3.926Z"
      />
    </G>
    <Path
      fill="#7084AF"
      d="M67.717 33.835V56.13H9.288V33.835c.353-.09.723-.14 1.104-.14h12.355a3.593 3.593 0 0 1 3.535 2.945l.51 2.78a3.59 3.59 0 0 0 3.534 2.946h16.353a3.594 3.594 0 0 0 3.535-2.945l.51-2.78a3.594 3.594 0 0 1 3.535-2.945h12.355c.381 0 .75.047 1.103.139Z"
    />
    <Path
      fill="#A9B7D2"
      d="m50.72 37.575-.51 2.78a3.594 3.594 0 0 1-3.534 2.946H30.322a3.593 3.593 0 0 1-3.534-2.946l-.51-2.78a3.594 3.594 0 0 0-3.534-2.946H10.388a4.388 4.388 0 0 0-4.389 4.389v18.785a6.24 6.24 0 0 0 6.24 6.24h52.52a6.24 6.24 0 0 0 6.24-6.24V39.018a4.388 4.388 0 0 0-4.388-4.389H54.255a3.593 3.593 0 0 0-3.535 2.946Z"
    />
    <Path
      fill="#D1D9E9"
      d="M10.973 57.803V39.018a4.389 4.389 0 0 1 4.39-4.389h-4.975a4.388 4.388 0 0 0-4.389 4.389v18.785a6.24 6.24 0 0 0 6.24 6.24h4.975a6.24 6.24 0 0 1-6.24-6.24Z"
    />
    <Rect width={17} height={4} x={37.999} y={27} fill="#A5AFC3" rx={2} />
    <Circle cx={66.999} cy={59} r={15} fill="#fff" />
    <Path
      fill="#FEA14B"
      fillRule="evenodd"
      d="M67 47c-6.623 0-12 5.377-12 12s5.377 12 12 12c6.622 0 12-5.377 12-12s-5.378-12-12-12Zm0 3.428c4.73 0 8.57 3.842 8.57 8.572 0 4.73-3.84 8.571-8.57 8.571-4.731 0-8.572-3.841-8.572-8.571 0-4.73 3.841-8.572 8.571-8.572Z"
      clipRule="evenodd"
    />
    <Path
      fill="#FEA14B"
      d="M67.371 64.486c-.354 0-.653-.094-.896-.28-.233-.196-.35-.486-.35-.868v-4.816c0-.383.117-.668.35-.854.243-.196.542-.294.896-.294.355 0 .649.098.882.294.243.186.364.471.364.854v4.816c0 .382-.121.672-.364.868-.233.186-.527.28-.882.28Zm0-8.092c-.42 0-.756-.108-1.008-.322-.242-.224-.364-.518-.364-.882s.122-.654.364-.868c.252-.215.588-.322 1.008-.322.411 0 .742.107.994.322.252.214.378.504.378.868s-.126.658-.378.882c-.242.214-.574.322-.994.322Z"
    />
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M16 24h19v19H16z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default EmptyFolder
